import { FONT_FAMILY_INTER } from '@shared-ui/assets/fonts/constants'
import type { Settings } from '@shared-ui/theme/types'

export const defaultSettings: Settings = {
  APP_PIN_CODE_LEN: 6,
  APP_MAX_PIN_ATTEMPT: 3,
  APP_DEFAULT_FONT_FAMILY: FONT_FAMILY_INTER,
  APP_RESEND_CODE_TIME: 60,
}

export const getSettings = (): Settings => defaultSettings
